<template>
  <div class="wrapper">
    <div class="order-address" v-if="mustbuy.pick_store_nbr">
      <div class="order-address-l">
        <div class="order-address-lr">
          <p><span>团长信息：{{mustbuy.pick_contacts}}</span></p>
          <p class="order-address-text">提货地址：{{mustbuy.pick_address||""}}</p>
        </div>
      </div>
    </div>
    <div class="order-address" @click="goaddresslist" v-else>
      <div class="order-address-l">
        <!-- <div class="order-address-ll">
          <img src="../../assets/images/icon_xzshdz.svg" alt>
        </div>-->
        <div class="order-address-lr" v-show="addressNbr!=''">
          <p>
            <span>收货人：{{address.contacts}}</span>
            <span>{{address.phone_no}}</span>
          </p>
          <p
            class="order-address-text"
          >{{address.province||""}}{{address.city||""}}{{address.district||""}} {{address.address||""}}</p>
        </div>
        <div class="order-address-lr" v-show="addressNbr==''">
          <p class="order-address-text">您还没有设置收货地址，请先设置收货地址</p>
        </div>
      </div>
      <div class="order-address-r">
        <img src="../../assets/images/icon_youjiantou.svg" alt />
      </div>
    </div>
    <div class="addressLine">
      <img src="../../assets/images/pattern.jpg" alt />
    </div>
    <!-- 客服时间 -->
    <van-notice-bar class="serverTime"
      :left-icon="require('../../assets/images/index/kfNotice.png')"
      color="#333333"
      :text="noticeStr"
      v-if="noticeStr"
      @click="noticeShow = true"
    />
    <van-popup v-model="noticeShow" :close-on-click-overlay="false" style="background:transparent">
      <div class="noticeBox">
        <div class="title">公告通知</div>
        <div class="contentArea">
          <div class="content"><span>{{noticeObj.contents}}</span></div>
            <img v-if="noticeObj.image_url" @click="showImage(noticeObj.image_url)" :src="noticeObj.image_url" alt="">
        </div>
        <div class="checkBtn" @click="noticeShow = false">我知道了</div>
      </div>
    </van-popup>
    <div class="toAddressInfo">
      <div class="main" v-if="Number(address.type)<Number(mustbuy.identity_type)">
        <div class="left">
          <img src="../../assets/images/ii.png" alt />
          <span>海外购商品请完善收货人身份信息</span>
        </div>
        <div @click="toAdressInfo(address.nbr)" class="right">
          <span>完善信息</span>
        </div>
      </div>
    </div>
    <!-- <div class="setting">
      <div class="settingLeft">
        <span>退换无忧 一键省心</span>
        <span>为所有商品购买运费险</span>
      </div>
      <van-switch style="font-size:.50rem" active-color="#4CD964" v-model="afterSaleChecked" @change="slip" />
    </div> -->
    <!-- 地址 -->
    <div class="prder-good">
      <div class="prder-goodm" v-for="(item,index) in mustbuy.commodity" :key="index">
        <div class="prder-goodm-flex">
          <div class="prder-goodml">
            <img :src="item.commodity_first_pic" alt />
          </div>
          <div class="prder-goodmr">
            <div
              class="prder-goodmrt more-h"
              style=" -webkit-box-orient: vertical;"
            >{{item.commodity_name}}</div>
            <div class="prder-goodmrm">
              {{item.property}}
              <span class>×{{item.quantity}}</span>
            </div>
            <div class="prder-goodmrb">
              <div class="prder-goodmrbl">￥{{item.sell_price}}</div>
              <!-- <div class="prder-goodmrbr">
                              <span @click="reduce">-</span><input type="number" v-model="num">
                              <span @click="add">+</span>
              </div>-->
            </div>
          </div>
        </div>

        <!-- 运费险 -->
        <div
          class="discount"
          style="border:0;height:.35rem;margin-top:.2rem;padding:0;align-items:center;line-height: normal;"
          v-if="item.is_safe != 0&&item.postage_safe&&item.postage_pay"
        >
          <div class="left">
            <div class="discount-l">运费险</div>
            <div>确认收货前退货可赔付{{item.is_safe==0?0:item.postage_pay}}元</div>
          </div>
          <div class="right" @click="showMoneys(index)" style="align-items:center;">
            <div class="discount-r">￥{{item.is_safe==0?0:item.postage_safe}}</div>
            <img src="../../assets/images/icon_xuanzhong.png" alt  v-if="item.useMoney" />
            <img src="../../assets/images/icon_weixuan.svg" alt v-else  />
          </div>
        </div>
      </div>
    </div>
    <!-- 留言 -->
    <div class="discount1">
      <div class="discount1-l">买家留言：</div>
      <div class="discount1-r">
        <input placeholder="选填" type="text" v-model="inp" />
      </div>
    </div>

    <div v-if="mustbuy.pick_store_nbr">
      <div class="zitiTitle" >
        <span>选择提货方式</span>
      </div>
      <div class="pickTypeItem" @click="changePickType('1')">
        <span>自提</span>
        <div class="paypopup-weixinr">
          <div class="radius1" v-if="pickType!='1'"></div>
          <img src="../../assets/images/icon_xuanzhong.png" alt v-else />
        </div>
      </div>
      <div class="pickTypeItem" @click="changePickType('0')">
        <span>快递</span>
        <div class="paypopup-weixinr">
          <div class="radius1" v-if="pickType!='0'"></div>
          <img src="../../assets/images/icon_xuanzhong.png" alt v-else />
        </div>
      </div>
    </div>
    <div class="zitiTitle" v-if="mustbuy.pick_store_nbr">
      <span>{{pickType=='1'?'自提':'快递'}}信息配置</span>
    </div>
    <div class="order-address" @click="goaddresslist" v-if="mustbuy.pick_store_nbr">
      <div class="order-address-l">
        <div class="order-address-lr" v-if="pickType=='1'" v-show="addressNbr!=''">
          <p><span>提货人名称：{{address.contacts}}</span></p>
          <p><span style="margin-bottom: 0;">提货人号码：{{address.phone_no}}</span></p>
        </div>
        <div class="order-address-lr" v-else v-show="addressNbr!=''">
          <p>
            <span>收货人：{{address.contacts}}</span>
            <span>{{address.phone_no}}</span>
          </p>
          <p
            class="order-address-text"
          >{{address.province||""}}{{address.city||""}}{{address.district||""}} {{address.address||""}}</p>
        </div>
        <div class="order-address-lr" v-show="addressNbr==''">
          <p class="order-address-text">您还没有设置收货地址，请先设置收货地址</p>
        </div>
      </div>
      <div class="order-address-r">
        <img src="../../assets/images/icon_youjiantou.svg" alt />
      </div>
    </div>
    <div class="addressLine" v-if="mustbuy.pick_store_nbr">
      <img src="../../assets/images/pattern.jpg" alt />
    </div>
    
    <div class="line"></div>
    <div class="discount">
      <div class="discount-l">商品金额</div>
      <div class="discount-r">￥{{parseFloat(mustbuy.sell_amount).toFixed(2)}}</div>
    </div>
    <div class="discount" v-if="parseFloat(mustbuy.jl_discount_amount||'0')>0">
      <div class="discount-l">会场折扣</div>
      <div class="discount-r">-￥{{parseFloat(mustbuy.jl_discount_amount||'0').toFixed(2)}}</div>
    </div>
    <!-- 折扣 @click="gocoupon(2)" -->
    <div class="discount"  v-if="areaCoupon.discount_nbr">
      <div class="discount-l">{{areaCoupon.discount_name}}</div>
      <!-- 满减折扣 -->
      <div
        class="discount-r"
        v-if="areaCoupon.discount_nbr"
        style="display: flex;justify-content: center;
        align-items: center;"
      >
        <span>-￥{{areaCoupon.limit_amount}}</span>
      </div>
    </div>
    <!-- 商品 -->
    <div class="discount" @click="gocoupon(1)" v-if="(mustbuy.is_use_coupon==1|| mustbuy.couple_num > 0)&&!(areaCoupon.type=='2'&&areaCoupon.is_use_coupon==0)">
      <div class="discount-l">优惠</div>
      <div
        class="discount-r"
        v-if="gocouponshow==false&&couple_num>0"
        style="display: flex;justify-content: center;
    align-items: center;"
      >
        <span style="color:#E52B25">{{couple_num}}张可用</span>
        <img src="../../assets/images/icon_youjiantou.svg" alt />
      </div>
      <div
        class="discount-r"
        v-if="gocouponshow==false&&couple_num==0"
        style="color:#ccc;display: flex;align-items: center;"
      >暂无可用优惠券</div>
      <div
        class="discount-r"
        v-if="gocouponshow==true"
        style="display: flex;justify-content: center;
    align-items: center;"
      >
        <span>-￥{{coupons.limit_amount}}</span>
        <img src="../../assets/images/icon_youjiantou.svg" alt />
      </div>
    </div>
    <div :class="mustbuy.postage_sum==0?'discount grey':'discount'">
      <div class="discount-l">运费</div>
      <div class="discount-r">+￥{{parseFloat(mustbuy.postage_sum).toFixed(2)}}</div>
    </div>
    <!-- 运费 -->
    <div class="dibu">
      <!-- <div class="dibu-l">共{{mustbuy.commodity.length}}件商品</div> -->
      <div class="dibu-m">
        总金额:
        <span
          style="font-size:.34rem"
          v-if="parseFloat(mustbuy.sell_amount)-parseFloat(mustbuy.jl_discount_amount||'0')-parseFloat(coupons.limit_amount)+parseFloat(mustbuy.postage_sum) > 0"
        >￥{{payAmount}}</span>
        <span v-else>￥0.00</span>
      </div>
      <div class="dibu-r" @click="pay">提交订单</div>
    </div>
    <!-- 底部 -->
    <div class="addpopup">
      <van-popup v-model="show">
        <div class="vanbox">
          <div class="vanboxt">您暂未选择收货地址是否现在选择？</div>
          <div class="vanboxb">
            <div class="vanboxbl" @click="close">取消</div>
            <div class="vanboxbr" @click="goaddress">确定</div>
          </div>
        </div>
      </van-popup>
    </div>
    <!-- 弹出提示地址 -->
    <div class="paypopup-wrap">
      <van-popup v-model="showup" position="bottom" :overlay="true" @click-overlay="payclose">
        <div class="paypopup">
          <div class="paypopup-close">
            <div class="paypopup-closel-x">请选择支付方式</div>
            <div class="paypopup-closel" @click="payclose">
              <img src="../../assets/images/icon_close.svg" alt />
            </div>
          </div>
          <div class="paypopup-amount">支付金额:￥{{payAmount}}</div>
          <div
            :class="parseFloat(user.balance)<=0?'paypopup-useBalance disabled':'paypopup-useBalance'"
          >
            <div class="useBalance-l">余额可抵扣</div>
            <div class="useBalance-r" @click="toUseBalance">
              <div
                class="useBalance-text"
              >￥{{parseFloat(user.balance)>=parseFloat(payAmount)?parseFloat(payAmount):parseFloat(user.balance)}}</div>
              <div class="radius1" v-if="!useBalance"></div>
              <img src="../../assets/images/icon_xuanzhong.png" alt v-else />
            </div>
          </div>
          <div class="paypopup-otherTitle">其他支付方式</div>
          <!-- <div
            class="paypopup-money"
            v-if="parseFloat(mustbuy.sell_amount)-parseFloat(coupons.limit_amount)+parseFloat(mustbuy.postage_sum) > 0"
          >¥{{(parseFloat(mustbuy.sell_amount)-parseFloat(coupons.limit_amount)+parseFloat(mustbuy.postage_sum)).toFixed(2)}}</div>
          <div class="paypopup-money" v-else>¥0.00</div>-->
          <!-- <div
          :class="xuanzhong1?'paypopup-balance':'paypopup-balance'"
          @click="xuanz1"
          &gt;
          <div class="paypopup-balancel">
          <img src="../../assets/images/icon_yezf.svg" alt />
          <span class="balancePay"><span class="text">余额支付</span><span class="red" v-if="parseFloat(user.balance)==0">当前余额为￥0，不可使用余额支付</span><span class="red" v-else-if="parseFloat(mustbuy.sell_amount)-parseFloat(coupons.limit_amount)+parseFloat(mustbuy.postage_sum)+parseFloat(postageSafe)-parseFloat(user.balance)>0">当前余额为￥{{parseFloat(user.balance)}}，微信需支付￥{{parseFloat((parseFloat(mustbuy.sell_amount)-parseFloat(coupons.limit_amount)+parseFloat(mustbuy.postage_sum)+parseFloat(postageSafe)-parseFloat(user.balance)).toFixed(2))}}</span></span>
          </div>
          <div class="paypopup-balancer">
          <div class="radius" v-if="user.balance==0"></div>
          <div class="radius1" v-else-if="!xuanzhong1"></div>
          <img src="../../assets/images/icon_xuanzhong.png" alt v-else />
          </div>
          </div> -->
          <div v-if="useNewYouths!='1'" :class="payState==4?'paypopup-weixin':'paypopup-weixin '" @click="xuanz5">
            <div class="paypopup-weixinl">
              <img src="../../assets/images/unionWeChat.png" alt />
              <span>微信支付</span>
            </div>
            <div class="paypopup-weixinr">
              <div class="radius1" v-if="payState!=4"></div>
              <img src="../../assets/images/icon_xuanzhong.png" alt v-else />
            </div>
          </div>
          <div class="linew" v-if="showAliPay&&useNewYouths!='1'"></div>
          <div
            v-if="showAliPay&&useNewYouths!='1'"
            :class="payState==2?'paypopup-weixin':'paypopup-weixin '"
            @click="xuanz3"
          >
            <div class="paypopup-weixinl">
              <img src="../../assets/images/aliPay.png" alt />
              <span>支付宝支付</span>
            </div>
            <div class="paypopup-weixinr">
              <div class="radius1" v-if="payState!=2"></div>
              <img src="../../assets/images/icon_xuanzhong.png" alt v-else />
            </div>
          </div>
          <div v-if="useNewYouths=='2'" class="linew"></div>
          <div v-if="useNewYouths!='0'" :class="payState==1?'paypopup-weixin':'paypopup-weixin '" @click="xuanz2">
            <div class="paypopup-weixinl">
              <img src="../../assets/images/icon_wxzf.svg" alt />
              <span>微信支付{{useNewYouths=='2'?'一':''}}</span>
            </div>
            <div class="paypopup-weixinr">
              <div class="radius1" v-if="payState!=1"></div>
              <img src="../../assets/images/icon_xuanzhong.png" alt v-else />
            </div>
          </div>
          <div v-if="useNewYouths!='0'" class="linew"></div>
          <div
            v-if="useNewYouths!='0'"
            :class="payState==3?'paypopup-weixin':'paypopup-weixin '"
            @click="xuanz4"
          >
            <div class="paypopup-weixinl">
              <img src="../../assets/images/aliPay.png" alt />
              <span>支付宝支付{{useNewYouths=='2'?'一':''}}</span>
            </div>
            <div class="paypopup-weixinr">
              <div class="radius1" v-if="payState!=3"></div>
              <img src="../../assets/images/icon_xuanzhong.png" alt v-else />
            </div>
          </div>
          <div
            class="paypopup-pay"
            @click="gopay"
          >{{useBalance? parseFloat(user.balance) < parseFloat(payAmount)?'还需支付￥'+Number((parseFloat(payAmount)-parseFloat(user.balance)).toFixed(2)):'立即支付':'立即支付￥'+payAmount}}</div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import ap from "@/assets/js/ap";
import { mapGetters } from "vuex";
import weChatShareApi from "../../assets/js/weChatShare";
import { handleText } from "./../../assets/js/tool";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      // num: "1", //加减数
      inp: "", //留言
      show: false, //提示地址信息
      showup: false, //支付弹窗
      showMoney: false,
      payState: 4,
      mustbuy: {
        commodity: [],
        postage_sum: 0
      }, //立即购买返回的数据
      address: {}, //地址
      orderdata: "", //生成订单返回的数据
      coupons: {
        nbr: "",
        limit_amount: 0
      }, //优惠券
      gocouponshow: false, //优惠券存在？
      gtotal_price: "", //单价加运费价格
      total_price: "", //支付价格
      addressNbr: "", // 默认地址编号
      paySwitch: true, // 订单生成开关
      goPaySwitch: true, //
      orderNbr: "", // 订单编号
      transSerialNbr: "", //流水号
      type: "", // 从哪里来 0商品 1购物车 2拼单
      weChatProp: {}, // 微信支付属性
      aliUrl: "",
      aliUrl_ys: "",
      weChatSwitch: true, //支付状态查询持续开关
      group_leader_nbr: "",
      postagePay: 0,
      postageSafe: 0,
      user: {},
      payType: "",
      couple_num: 0, //可使用优惠券数量
      supportType: 0, //是否支持运费险
      keepAlive: false,
      useBalance: false,
      useNewYouths:'1',
      testArr: [
        "7193101",
        "18428194",
        "7191977",
        "7433002",
        "7193234",
        "7452877",
        "16295004",
        "18457203",
        "18520355",
        "9326463",
        "18247403",
        "18083662",
        "17608686",
        "18347192",
        "18346055",
        "18402811",
        "18468695",
        "18354296",
        "13656998",
        "18457203",
        "18346286",
        "15494770",
        "18352967",
        "18349301"
      ],
      areaCoupon:{},

      noticeObj:{},
      noticeStr:'',
      noticeShow: false,

      afterSaleChecked:false,
      pickType:'1',
    };
  },
  watch: {
    $route(to, from) {
      if (from.path == "/addresslist" || from.path == "/couponCommodity") {
        this.keepAlive = true;
      } else {
        this.keepAlive = false;
      }
    }
  },
  computed: {
    allAmount() {
      let amount = parseFloat(this.mustbuy.sell_amount) + parseFloat(this.mustbuy.postage_sum) - parseFloat(this.mustbuy.jl_discount_amount||'0') 
      this.mustbuy.commodity.map(item=>{
        if(item.useMoney){
          amount += parseFloat(item.postage_safe||0)
        }
      })
      return Number(amount.toFixed(2));
    },
    payAmount() {
      let payAmount =
        parseFloat(this.allAmount) - parseFloat(this.coupons.limit_amount) - parseFloat(this.areaCoupon.limit_amount||0);
      return Number(payAmount.toFixed(2));
    },
    ...mapGetters(["selectaddress","coupon", "userInfo"])
  },
  methods: {
    changePickType(type){
      if(this.pickType==type) return false
      this.pickType = type
    },
    slip() {
      let afterSaleChecked = this.afterSaleChecked;
      this.mustbuy.commodity.map(item=>{
        if(item.is_safe!='0' && item.useMoney != afterSaleChecked){
          item.useMoney = afterSaleChecked
        }
      })
      // this.$forceUpdate();
    },
    toAdressInfo(nbr) {
      this.$router.push({
        path: "/addaddress",
        query: {
          nbr: nbr,
          showType: this.mustbuy.identity_type,
          supNbr: this.userInfo.nbr
        }
      });
    },
    showMoneys(index) {
      this.$set(this.mustbuy.commodity[index], 'useMoney' ,!Boolean(this.mustbuy.commodity[index].useMoney))
    },
    toUseBalance() {
      let balance = parseFloat(this.user.balance);
      if (balance <= 0) {
        return false;
      }
      this.useBalance = !this.useBalance;
    },
    close() {
      this.show = false;
    },
    goaddress() {
      var address = 1;
      this.$router.push({
        path: "/addresslist",
        query: { address: address, supNbr: this.userInfo.nbr }
      });
      // if (Number(this.address.type)<Number(this.mustbuy.identity_type)){
      //   this.$router.push({ path: "/addresslist", query: { address: address,show:true } });
      // }else{

      // }
    },
    goaddresslist() {
      var address = 1;
      this.$router.push({
        path: "/addresslist",
        query: { address: address, supNbr: this.userInfo.nbr }
      });
      // if (Number(this.address.type)<Number(this.mustbuy.identity_type)){
      //   this.$router.push({ path: "/addresslist", query: { address: address,show:true } });
      // }else{

      // }
    },
    gocoupon(type) {
      let arr = [];
      let commodityArr = this.mustbuy.commodity;
      commodityArr.map(item => {
        arr.push(item.nbr);
      });
      commodityArr.map(item => {
        arr.push(item.nbr);
      });
      let newArr = new Set(arr);
      arr = Array.from(newArr);
      let price = parseFloat(this.mustbuy.sell_amount) -parseFloat(this.areaCoupon.limit_amount||0)
        // type==1?
        // (this.coupons.totalprice||(
        //   parseFloat(this.mustbuy.sell_amount) -parseFloat(this.areaCoupon.limit_amount||0)
        // ))
        // :(this.areaCoupon.totalprice||(
        //   parseFloat(this.mustbuy.sell_amount) -parseFloat(this.coupons.limit_amount||0))
        //  )
      ;
      this.$router.push({
        path: "/couponCommodity",
        query: {
          supNbr: this.userInfo.nbr,
          price: price,
          arr: JSON.stringify(arr),
          type: type,
        }
      });
    },
    record() {
      let arr = JSON.parse(this.$route.query.record).nbr;
      let newArr = [];
      for (let i in arr) {
        newArr.push({ nbr: arr[i],is_use_safe:this.mustbuy.commodity[i].useMoney?1:0 });
      }
      return newArr;
    },
    pay() {
      if (this.addressNbr == "")
        return this.$toast({
          message: "请选择收货地址",
          duration: 2000
        });
      if (Number(this.address.type) < Number(this.mustbuy.identity_type)) {
        return this.$toast({
          message: "请完善收货地址",
          duration: 2000
        });
      }
      if(this.mustbuy.is_show_error&& this.mustbuy.error_message){
        return this.$toast({
          message: this.mustbuy.error_message,
          duration: 2000
        });
      }
      let toast = this.$toast.loading({
        mask: true,
        message: "加载中...",
        duration: 0
      });
      if (!this.paySwitch) return false;
      this.paySwitch = false;
      let obj = {};
      let record,recordList;
      if (this.type == 1) {
        record = this.record();
        let nbrList = JSON.parse(this.$route.query.record).nbr;
        recordList = nbrList.join(',')
      }
      let is_use_safe = this.mustbuy.commodity[0].useMoney?1:0;
      // 1单个 2多个 3发团 4参团
      this.type == 0
        ? (obj = {
            jydm: "flow_10000",
            flow_10000: {
              sub_flow: "flow_30030",
              user_nbr: this.userInfo.nbr,
              commodity_nbr: this.mustbuy.commodity[0].nbr,
              inventory_nbr: this.$route.query.inventory_nbr,
              quantity: this.mustbuy.commodity[0].quantity,
              address_nbr: this.addressNbr,
              message: this.inp,
              area_discount_nbr: this.areaCoupon.discount_nbr,
              coupon_received_nbr: this.coupons.received_nbr,
              jl_discount_amount: this.mustbuy.jl_discount_amount||'',
              is_use_safe: is_use_safe,
              is_pickup_commodity: this.mustbuy.pick_store_nbr?this.pickType:'0',
              pickup_store_nbr: this.mustbuy.pick_store_nbr||'',
              sys_version: '1',
              version: '231',
            }
          })
        : this.type == 1
        ? (obj = {
            jydm: "flow_10000",
            flow_10000: {
              sub_flow: "flow_30031",
              user_nbr: this.userInfo.nbr,
              address_nbr: this.addressNbr,
              message: this.inp,
              coupon_received_nbr: this.coupons.received_nbr,
              area_discount_nbr: this.areaCoupon.discount_nbr,
              jl_discount_amount: this.mustbuy.jl_discount_amount||'',
              record: record,
              record_list: recordList,
              sys_version: '1',
              version: '231',
            }
          })
        : this.type == 2
        ? (obj = {
            jydm: "flow_80001",
            flow_80001: {
              user_nbr: this.userInfo.nbr,
              group_nbr: this.$route.query.group_nbr,
              group_inventory_nbr: this.$route.query.inventory_nbr,
              quantity: this.$route.query.quantity,
              address_nbr: this.addressNbr,
              message: this.inp,
              is_use_safe: is_use_safe
            }
          })
        : this.type == 3
        ? (obj = {
            jydm: "flow_80002",
            flow_80002: {
              user_nbr: this.userInfo.nbr,
              group_leader_nbr: this.group_leader_nbr,
              group_inventory_nbr: this.$route.query.inventory_nbr,
              quantity: this.$route.query.quantity,
              address_nbr: this.addressNbr,
              message: this.inp,
              is_use_safe: is_use_safe
            }
          })
        : "";

      this.$commonPost(obj)
        .then(response => {
          toast.clear();
          this.orderNbr = response.order_nbr;
          if (response.group_leader_nbr)
            this.group_leader_nbr = response.group_leader_nbr;
          this.$store.commit("SENDcoupon", "");
          this.showup = true;
        })
        .catch(err => {
          toast.clear();
          this.showup = false;
          this.paySwitch = true;
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    payclose() {
      this.showup = false;
      this.$router.go(-1);
    },
    xuanz1() {
      if (this.user.balance == 0) {
        return false;
      }
      this.$forceUpdate();
    },
    xuanz2() {
      this.payState = 1;
      this.$forceUpdate();
    },
    xuanz3() {
      this.payState = 2;
      this.$forceUpdate();
    },
    xuanz4() {
      this.payState = 3;
      this.$forceUpdate();
    },
    xuanz5() {
      this.payState = 4;
      this.$forceUpdate();
    },
    gopay() {
      let that = this;
      if (!this.goPaySwitch) return false;
      this.goPaySwitch = false;
      let toast = this.$toast.loading({
        mask: true,
        message: "加载中...",
        duration: 0
      });
      let useBalance = this.useBalance;
      let payAmount = parseFloat(that.payAmount);
      let balance = parseFloat(that.user.balance);
      if (useBalance && balance >= payAmount) {
        that.payType = "BALANCE";
      } else if (this.payState == 1) {
        that.payType = "YOUTHSNEWPUBLICPAY";
      } else if (this.payState == 2) {
        that.payType = "ALIPAYWAP";
      } else if (this.payState == 3) {
        that.payType = "YOUTHSNEWALIPAYWAP";
      } else if (this.payState == 4) {
        that.payType = "YOUTHSPUBLICPAY";
      }
      async function readyPay() {
        return new Promise((resolve, reject) => {
          that.readyPay(resolve, reject);
        });
      }
      async function pay() {
        if (that.payType == "BALANCE") {
          return new Promise((resolve, reject) => {
            that.balancePay(resolve, reject);
          });
        } else if (
          that.payType == "YOUTHSNEWPUBLICPAY" ||
          that.payType == "UNIONPUBLICPAY"
        ) {
          return new Promise((resolve, reject) => {
            that.weChatPay(resolve, reject);
          });
        } else if (that.payType == "ALIPAYWAP") {
          return new Promise((resolve, reject) => {
            that.AliPay(resolve, reject);
          });
        } else if (that.payType == "YOUTHSNEWALIPAYWAP") {
          return new Promise((resolve, reject) => {
            that.AliPay_ys(resolve, reject);
          });
        }else if (that.payType == "YOUTHSPUBLICPAY") {
          return new Promise((resolve, reject) => {
            that.weChatPay(resolve, reject);
          });
        }
      }
      async function goPayMoney(toast) {
        await readyPay();
        await pay(toast);
      }
      goPayMoney(toast);
    },
    readyPay(resolve, reject) {
      let that = this;
      let openid = localStorage.getItem("openid");
      let useBalance = this.useBalance;
      let useNewPayProcess= localStorage.getItem("otherConfig_10025");
      if (
        useBalance &&
        parseFloat(that.payAmount) > parseFloat(that.user.balance)
      ) {
        if(useNewPayProcess=='0'){
          that.$post("/api/pay/readyBalanceUnionPay", {
            userNbr: that.userInfo.nbr,
            orderNbr: that.orderNbr,
            paymentUnionMethod: "BALANCECASHUNION",
            paymentMethod: that.payType,
            openid: openid,
            balanceAmount: that.user.balance
          })
          .then(data => {
            if (that.payType == "ALIPAYWAP") {
              that.aliUrl = data;
              resolve();
              return false;
            }
         
            if (data.code == 200) {
              let resp = data.object.resp;
              if (that.payType == "YOUTHSNEWALIPAYWAP") {
                that.aliUrl_ys = resp.resp.prepayUrl;
                resolve();
                return false;
              }
              if (resp.resp_code == 0 && resp.resp_result == 0) {
                that.weChatProp = resp.resp;
                resolve();
              } else {
                reject();
                that.goPaySwitch = true;
                that.$toast({
                  message: res.resp_msg,
                  duration: 2000
                });
              }
            } else {
              reject();
              that.goPaySwitch = true;
              that.$toast({
                message: data.message,
                duration: 2000
              });
            }
          })
          .catch(err => {
            reject();
            that.goPaySwitch = true;
            that.$toast({
              message: err.message,
              duration: 2000
            });
          });
        }else if(useNewPayProcess=='1'){
          that.$commonPost({
            jydm: "flow_10000",
            flow_10000: {
              sub_flow: 'flow_30062',
              user_nbr: that.userInfo.nbr,
              order_nbr: that.orderNbr,
              balance_amount: that.user.balance,
            }
          }).then(data => {
            if (data.resp_code == 0 && data.resp_result == 0) {
              that.rechargePay(data.recharge_order_nbr, resolve, reject)
            } else {
              reject();
              that.goPaySwitch = true;
              that.$toast({
                message: data.resp_msg,
                duration: 2000
              });
            }
          })
          .catch(err => {
            reject();
            that.goPaySwitch = true;
            that.$toast({
              message: err.message,
              duration: 2000
            });
          });
        }
      } else {
        that.$post("/api/pay/readyPay", {
            userNbr: that.userInfo.nbr,
            orderNbr: that.orderNbr,
            paymentMethod: that.payType,
            openid: openid
          })
          .then(data => {
            if (that.payType == "ALIPAYWAP") {
              that.aliUrl = data;
              resolve();
              return false;
            }
            if (data.code == 200) {
              let resp = data.object.resp;
              if (that.payType == "YOUTHSNEWALIPAYWAP") {
                that.aliUrl_ys = resp.resp.prepayUrl;
                resolve();
                return false;
              }
              if (resp.resp_code == 0 && resp.resp_result == 0) {
                if (that.payType == "BALANCE") {
                  that.transSerialNbr = resp.transSerialNbr;
                  resolve();
                }
                if (
                  that.payType == "YOUTHSNEWPUBLICPAY" ||
                  that.payType == "UNIONPUBLICPAY" ||
                  that.payType == "YOUTHSPUBLICPAY"
                ) {
                  that.weChatProp = resp.resp;
                  resolve();
                }
              } else {
                reject();
                that.goPaySwitch = true;
                that.$toast({
                  message: res.resp_msg,
                  duration: 2000
                });
              }
            } else {
              reject();
              that.goPaySwitch = true;
              that.$toast({
                message: data.message,
                duration: 2000
              });
            }
          })
          .catch(err => {
            reject();
            that.goPaySwitch = true;
            that.$toast({
              message: err.message,
              duration: 2000
            });
          });
      }
    },
    rechargePay(orderNbr, resolve, reject){
      let that = this
      let openid = localStorage.getItem("openid");
      that.$post("/api/recharge/readyPay", {
          userNbr: that.userInfo.nbr,
          orderNbr: orderNbr,
          paymentMethod: that.payType,
          openid: openid
        })
        .then(data => {
          if (that.payType == "ALIPAYWAP") {
            that.aliUrl = data;
            resolve();
            return false;
          }
          if (data.code == 200) {
            let resp = data.object.resp;
            if (that.payType == "YOUTHSNEWALIPAYWAP") {
              that.aliUrl_ys = resp.resp.prepayUrl;
              resolve();
              return false;
            }
            if (resp.resp_code == 0 && resp.resp_result == 0) {
              if (that.payType == "BALANCE") {
                that.transSerialNbr = resp.transSerialNbr;
                resolve();
              }
              if (
                that.payType == "YOUTHSNEWPUBLICPAY" ||
                that.payType == "UNIONPUBLICPAY" ||
                that.payType == "YOUTHSPUBLICPAY"
              ) {
                that.weChatProp = resp.resp;
                resolve();
              }
            } else {
              reject();
              that.goPaySwitch = true;
              that.$toast({
                message: res.resp_msg,
                duration: 2000
              });
            }
          } else {
            reject();
            that.goPaySwitch = true;
            that.$toast({
              message: data.message,
              duration: 2000
            });
          }
        })
        .catch(err => {
          reject();
          that.goPaySwitch = true;
          that.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    balancePay(resolve, reject) {
      this.$post("/api/pay/balancePay", {
        transSerialNbr: this.transSerialNbr
      })
        .then(data => {
          if (data.code == 200) {
            let resp = data.object.resp;
            if (resp.resp_code == 0 && resp.resp_result == 0) {
              resolve();
              this.$toast({
                message: resp.resp_msg,
                duration: 2000
              });
              this.showup = false;
              if (this.type == 0 || this.type == 1) {
                this.$router.replace({
                  path: "/payResultFollow",
                  query: {
                    supNbr: this.userInfo.nbr,
                    orderNbr: this.orderNbr
                  }
                });
              }
              if (this.type == 2 || this.type == 3) {
                let stateNum = 200;
                if (this.type == 3) stateNum = 201;
                this.$router.replace({
                  path: "/payResultFollow",
                  query: {
                    state: stateNum,
                    group_leader_nbr: this.group_leader_nbr,
                    supNbr: this.userInfo.nbr,
                    orderNbr: this.orderNbr
                  }
                });
              }
            } else {
              reject();
              setTimeout(() => {
                this.$router.go(-1);
              }, 2000);
              this.$toast({
                message: resp.resp_msg,
                duration: 2000
              });
            }
          } else {
            reject();
            setTimeout(() => {
              this.$router.go(-1);
            }, 2000);
            this.$toast({
              message: data.message,
              duration: 2000
            });
          }
          this.goPaySwitch = true;
        })
        .catch(err => {
          this.goPaySwitch = true;
          setTimeout(() => {
            this.$router.go(-1);
          }, 2000);
          reject();
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    weChatPay(resolve, reject) {
      let that = this;
      let weChatPayInfo = that.weChatProp;
      function jsApiCall() {
        WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          {
            appId: weChatPayInfo.appId, //公众号名称，由商户传入
            timeStamp: weChatPayInfo.timeStamp, //时间戳，自1970年以来的秒数
            nonceStr: weChatPayInfo.nonceStr, //随机串
            package: "prepay_id=" + weChatPayInfo.prepayid,
            signType: weChatPayInfo.signType, //微信签名方式：
            paySign: weChatPayInfo.sign //微信签名
          },
          function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              that.checkWeChatSuccess(resolve, reject);
              let timer = setTimeout(() => {
                that.weChatSwitch = false;
              }, 60000);
            } else if (
              res.err_msg == "get_brand_wcpay_request:cancel" ||
              res.err_msg == "get_brand_wcpay_request:fail"
            ) {
              setTimeout(() => {
                that.$router.go(-1);
              }, 2000);
              that.$toast({
                message: "支付失败",
                duration: 2000
              });
            }
          }
        );
      }
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener("WeixinJSBridgeReady", jsApiCall, false);
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", jsApiCall);
          document.attachEvent("onWeixinJSBridgeReady", jsApiCall);
        }
      } else {
        jsApiCall();
      }
    },
    AliPay() {
      let that = this;
      let aliUrl = "https://openapi.alipay.com/gateway.do?" + that.aliUrl;
      _AP.pay(aliUrl);
    },
    AliPay_ys() {
      let that = this;
      let aliUrl =  that.aliUrl_ys;
      _AP.pay(aliUrl);
    },
    checkWeChatSuccess(resolve, reject) {
      this.$post("/api/pay/order/checkPaySuccess", {
        orderNbr: this.orderNbr
      })
        .then(data => {
          if (data.code == 200) {
            let resp = data.object.resp;
            if (resp.resp_code == 0) {
              if (resp.resp_result == 0) {
                this.$toast({
                  message: "支付成功",
                  duration: 2000
                });
                resolve();
                if (this.type == 0 || this.type == 1) {
                  this.$router.replace({
                    path: "/payResultFollow",
                    query: {
                      supNbr: this.userInfo.nbr,
                      orderNbr: this.orderNbr
                    }
                  });
                }
                if (this.type == 2 || this.type == 3) {
                  let stateNum = 200;
                  if (this.type == 3) stateNum = 201;
                  this.$router.replace({
                    path: "/payResultFollow",
                    query: {
                      state: stateNum,
                      group_leader_nbr: this.group_leader_nbr,
                      supNbr: this.userInfo.nbr,
                      orderNbr: this.orderNbr
                    }
                  });
                }
              } else if (resp.resp_result == 2 && this.weChatSwitch) {
                setTimeout(() => {
                  this.checkWeChatSuccess(resolve, reject);
                }, 1000);
              } else {
                this.$router.go(-1);
                this.$toast({
                  message: "支付失败",
                  duration: 2000
                });
                reject();
              }
            } else {
              this.$router.go(-1);
              this.$toast({
                message: resp.resp_msg,
                duration: 2000
              });
              reject();
            }
          } else {
            this.$router.go(-1);
            this.$toast({
              message: data.message,
              duration: 2000
            });
            reject();
          }
        })
        .catch(err => {
          this.$router.go(-1);
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getCommodityOne(toast) {
      // 商品详情
      this.$commonPost({
        jydm: "flow_30017",
        flow_30017: {
          inventory_nbr: this.$route.query.inventory_nbr,
          quantity: this.$route.query.quantity,
          user_nbr: this.userInfo.nbr,
          address_nbr: this.addressNbr,
          version: '231'
        }
      })
        .then(response => {
          let arr = [];
          if (response.commodity.length > 0) {
            arr = response.commodity;
          } else {
            arr.push(response.commodity);
          }
          response.identity_type = response.commodity.identity_type;
          arr[0].useMoney = this.$route.query.postageBuy==1
          if(response.pick_address) response.pick_address = handleText(response.pick_address)
          response.commodity = arr;
          this.mustbuy = response;
          this.getAreaCouponNum()
          this.$forceUpdate(); //重绘
          toast.clear();
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getCommodityList(toast) {
      // 商品详情
      this.$commonPost({
        jydm: "flow_30019",
        flow_30019: {
          record: JSON.parse(this.$route.query.record),
          user_nbr: this.userInfo.nbr,
          address_nbr: this.addressNbr,
          version: '231'
        }
      })
        .then(response => {
          let arr = [];
          if (response.commodity.length > 0) {
            arr = response.commodity;
          } else {
            arr.push(response.commodity);
          }
          arr.map(item => {
            item.nbr = item.commodity_nbr;
            item.useMoney = false
          });
          response.commodity = arr;
          this.mustbuy = response;
          this.getAreaCouponNum()
          this.$forceUpdate(); //重绘
          toast.clear();
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getPurchaseCommodity(toast) {
      // 商品拼单详情
      this.$commonPost({
        jydm: "flow_80010",
        flow_80010: {
          inventory_nbr: this.$route.query.inventory_nbr,
          quantity: this.$route.query.quantity,
          user_nbr: this.userInfo.nbr,
          address_nbr: this.addressNbr,
          leader_nbr: this.group_leader_nbr || "",
          wechat_version: 1
        }
      })
        .then(response => {
          let arr = [];
          if (response.commodity.length > 0) {
            arr = response.commodity;
          } else {
            arr.push(response.commodity);
          }
          response.identity_type = response.commodity.identity_type;
          arr[0].useMoney = this.$route.query.postageBuy==1
          response.commodity = arr;
          this.mustbuy = response;
          this.getCouponNum();
          this.$forceUpdate(); //重绘
          toast.clear();
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getCouponNum() {
      let arr = [];
      let commodityArr = this.mustbuy.commodity;
      commodityArr.map(item => {
        arr.push(item.nbr);
      });
      let newArr = new Set(arr);
      arr = Array.from(newArr);
      // 商品拼单详情
      this.$commonPost({
        jydm: "flow_70132",
        flow_70132: {
          user_nbr: this.userInfo.nbr,
          price: (
            parseFloat(this.mustbuy.sell_amount) -
            parseFloat(this.mustbuy.jl_discount_amount||0) -
            parseFloat(this.areaCoupon.limit_amount||0)
          ).toFixed(2),
          commodity: {
            nbr: arr
          },
          page_index: 0,
          num_per_page: 1
        }
      })
        .then(response => {
          this.couple_num = response.total_rows;
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        })
    },
    getAreaCouponNum(){
      let arr = [];
      let commodityArr = this.mustbuy.commodity;
      commodityArr.map(item => {
        arr.push({
          nbr:item.nbr,
          inventory_nbr:item.inventory_nbr,
          quantity:item.quantity,
        });
      });
      let newArr = new Set(arr);
      arr = Array.from(newArr);
      // 商品折扣券详情
      this.$commonPost({
        jydm: "flow_70249",
        flow_70249: {
          user_nbr: this.userInfo.nbr,
          user_role: this.user.role,
          total_price: (
            parseFloat(this.mustbuy.sell_amount) -
            parseFloat(this.mustbuy.jl_discount_amount||0)
          ).toFixed(2),
          commodity: arr
        }
      })
        .then(response => {
          let arr=[]
          if(response.discount){
            if(response.discount.length>0){
              arr = response.discount
            }else{
              arr.push(response.discount)
            }
          }
          this.areaCoupon =arr.length>0? arr[0]:{}
          this.couple_num = 0;
          if(this.areaCoupon.type=='2'&&this.areaCoupon.is_use_coupon==0) return false
          this.getCouponNum();
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getAddress(resolve, reject) {
      // 用户的默认地址
      this.$commonPost({
        jydm: "flow_10010",
        flow_10010: {
          user_nbr: this.userInfo.nbr
        }
      })
        .then(response => {
          let obj = {};
          if (response.address) {
            obj = response.address;
            obj.address = handleText(obj.address);
            this.addressNbr = response.address.nbr;
            this.$store.commit("SENDselectaddress", obj);
          } else {
            this.addressNbr = "";
          }
          this.address = obj;
          resolve();
        })
        .catch(err => {
          reject();
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getCoupons() {
      if (this.coupon) {
        this.coupons = this.coupon;
        this.gocouponshow = true;
      } else {
        this.coupons = {
          nbr: "",
          limit_amount: 0
        };
        this.gocouponshow = false;
      }
    }
  },
  created() {
    document.title = "提交订单";
  },
  mounted() {
    document.title = "提交订单";
  },
  activated() {
    document.title = "提交订单";
    let option = {
      title: "有米@" + this.userInfo.name + "的店铺",
      desc: "欢迎光临我的店铺",
      link: location.origin + "/?supNbr=" + this.userInfo.nbr,
      images: this.userInfo.imgUrl
    };
    this.weChatShare(option);

    // 用户的基本信息(身份)
    this.$commonPost({
      jydm: "flow_10003",
      flow_10003: {
        user_nbr: this.userInfo.nbr
      }
    })
      .then(response => {
        this.user = response;
      })
      .catch(err => {
        this.$toast({
          message: err.message,
          duration: 2000
        });
      });

    //公告内容
    this.$commonPost({
      jydm: "flow_70203",
      flow_70203: {
        type:'2',
        page_index: 0,
        num_per_page: 10,
      }
    })
      .then(response => {
      let arr = [];
      if(response.list){
        if(response.list.length > 0){
          arr = response.list
        }else{
          arr.push(response.list)
        }
      }
      let noticeObj = arr[0]||{}
      let str =  (noticeObj.contents||'') //+ (noticeObj.image_url?'  [图片]':'')
      let newStr = str
      if(str){
        for(let i=0;i<100;i++){
          newStr+='\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0'+str
        }
      }
      this.noticeObj = arr[0]||{}
      this.noticeStr = newStr
    })
    .catch(err => {});

    if (!this.keepAlive) {
      this.group_leader_nbr = "";
      this.postageSafe = 0;
      this.mustbuy = {
        commodity: [],
        postage_sum: 0,
        sell_amount: 0
      };
      this.areaCoupon = {}
      this.inp = "";
      this.showMoney = false;
      this.useBalance = false;
      this.coupons = {
        nbr: "",
        limit_amount: 0
      };
    }
    this.afterSaleChecked = false
    this.paySwitch = true;
    this.goPaySwitch = true;
    let that = this;
    let type = this.$route.query.type;
    let group_leader_nbr = this.$route.query.group_leader_nbr;
    if (!type || type == "") type = 0;
    this.type = type;
    if (group_leader_nbr) this.group_leader_nbr = group_leader_nbr;

    this.supportType = localStorage.getItem("otherConfig_10009");
    // this.useNewYouths = localStorage.getItem("otherConfig_10024");

    if(this.useNewYouths!='1'){
        this.payState=4
    }else if(this.useNewYouths=='1'){
      this.payState=1
    }else{
      this.payState=4
    }
    let toast = this.$toast.loading({
      mask: false,
      duration: 0
    });
    async function getAddress() {
      return new Promise((resolve, reject) => {
        that.getAddress(resolve, reject);
      });
    }
    async function getDataWait(type) {
      if (type == 0) {
        that.getCommodityOne(toast);
      } else if (type == 1) {
        that.getCommodityList(toast);
      } else if (type == 2 || type == 3) {
        that.getPurchaseCommodity(toast);
      }
    }
    async function getAllData(type) {
      if (that.selectaddress) {
        that.address = that.selectaddress;
        that.addressNbr = that.selectaddress.nbr;
      } else {
        await getAddress();
      }
      getDataWait(type);
    }
    getAllData(type);
    this.getCoupons();
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name == "sourceListdetail" ||
      to.name == "listdetail" ||
      to.name == "cart" ||
      to.name == "myorder" ||
      to.name == "purchaseCommdity"
    ) {
      this.$store.commit("SENDcoupon", "");
      this.$store.commit("SENDselectaddress", "");
      this.$store.commit("SENDAreaCoupon", "");
    }
    next();
  },
  destroyed() {}
};
</script>
<style scoped lang='stylus'></style>
<style scoped lang='less'>
.addressLine {
  width: 100%;
  height: 0.06rem;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
    height: 0.06rem;
  }
}
.wrapper {
  width: 100%;
  min-height: 100vh;
  background: #f7f7f7;
  padding-bottom: 1.08rem;
  box-sizing: border-box;
}
.order-address {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0.32rem 0.24rem;
  background: #fff;
  height: 1.16rem;
  align-items: center;
}
.order-address-lr {
  position: relative;
}
.order-address-l {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.order-address-l p {
  font-size: 0.28rem;
  color: #333333;
}
.order-address-l p > span:nth-child(1) {
  width: 3.68rem;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  word-break: break-all;
  margin-bottom: 0.2rem;
  line-height: 0.33rem;
}
.order-address-l p > span:nth-child(2) {
  position: absolute;
  top: 0;
  left: 3.96rem;
}
.order-address-r {
  line-height: 1.2rem;
}
.order-address-text {
  width: 5.5rem;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-all;
  line-height: 0.32rem;
}
.toAddressInfo {
  min-height: 0.2rem;
  box-sizing: border-box;
  padding: 0 0.24rem;
  .main {
    display: flex;
    height: 0.76rem;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      img {
        width: 0.34rem;
        height: 0.34rem;
        margin-right: 0.1rem;
      }
      span {
        color: #e52b25;
        font-size: 0.24rem;
        font-weight: 500;
      }
    }
    .right {
      width: 1.26rem;
      height: 0.4rem;
      border-radius: 0.2rem;
      border: 1px solid #e52b25;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        color: #e52b25;
        font-size: 0.24rem;
        font-weight: 500;
        line-height: 0;
      }
    }
  }
}
.prder-good {
  width: 100%;
  background: #fff;
  overflow: hidden;
}
.linew {
  width: calc(100% - 1.04rem);
  height: 1px;
  margin-left: 1.04rem;
  background: #eee;
}
.prder-goodm {
  display: flex;
  flex-direction: column;
  margin: 0 0.24rem;
  margin-top: 0.24rem;
  padding-bottom: 0.25rem;
  border-bottom: 1px solid #eee;
  .prder-goodm-flex{
    display: flex;
    flex-direction: row;
  }
  &:last-child{
    border-bottom: 0;
  }
}
.prder-goodml img {
  width: 1.68rem;
  height: 1.68rem;
  object-fit: cover;
}
.prder-goodmr {
  width: 5.18rem;
  margin-left: 0.28rem;
}
.prder-goodmr span {
  font-size: 0.24rem;
  color: #666666;
}
.prder-goodmrt {
  line-height: 0.32rem;
  font-size: 0.24rem;
  font-weight: bold;
  color: #333333;
}
.prder-goodmrm {
  margin-top: 0.1rem;
  color: #999;
  font-size: 0.22rem;
  display: flex;
  justify-content: space-between;
  line-height: 0.3rem;
}
.prder-goodmrb {
  width: 4.5rem;
  margin-top: 0.2rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.prder-goodmrbl {
  font-size: 0.28rem;
  color: #e52b25;
  line-height: 0.4rem;
}
.prder-goodmrbr span {
  display: inline-block;
  width: 0.44rem;
  height: 0.44rem;
  text-align: center;
  line-height: 0.44rem;
  background: #f8f8f8;
  vertical-align: middle;
}
.prder-goodmrbr input {
  width: 1.36rem;
  height: 0.44rem;
  background: #f8f8f8;
  text-align: center;
  border: none;
  outline: 0;
  margin: 0 0.05rem;
  padding-top: 0.01rem;
  vertical-align: middle;
}
.discount {
  padding: 0 0.28rem;
  display: flex;
  flex-direction: row;
  line-height: 0.96rem;
  justify-content: space-between;
  border-bottom: 1px solid #ebebeb;
  background: #fff;
}
.discount1 {
  padding: 0 0.28rem;
  display: flex;
  flex-direction: row;
  line-height: 0.98rem;
  border-top: 1px solid #ebebeb;
  background: #fff;
}
.discount1-r {
  flex: 1;
}
.discount1-r input {
  width: 100%;
  border: none;
  outline: 0;
  line-height: 0.9rem;
  margin-top: -0.08rem;
}
.discount1-r input::placeholder {
  color: #999;
}
.discount1-r input::-moz-placeholder {
  color: #999;
}
.left {
  display: flex;
  div:last-child {
    margin-left: 0.16rem;
    font-size: 0.24rem;
    color: #999999;
  }
}
.right {
  display: flex;
  align-items: center;
  div {
    margin-right: 0.18rem;
    font-size: 0.24rem;
    color: #999999;
  }
  img {
    width: 0.34rem;
    height: 0.34rem;
  }
}
.dibu {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 1.08rem;
  line-height: 1.08rem;
  background: #fff;
  position: fixed;
  color: #e52b25;
  bottom: 0;
  padding-left: 0.24rem;
  left: 0;
  font-size: 0.28rem;
  box-sizing: border-box;
}
.dibu-l {
  margin-left: 0.28rem;
}
.dibu-m span {
  color: #e52b25;
}
.dibu-r {
  width: 1.86rem;
  height: 0.78rem;
  background: #e52b25;
  color: #fff;
  font-size: 0.32rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.39rem;
  margin-top: 0.15rem;
  margin-right: 0.24rem;
}
.vanbox {
  width: 5.18rem;
  height: 2.96rem;
  border-radius: 0.2rem;
  overflow: hidden;
}
.vanboxt {
  margin: 0 auto;
  width: 3.08rem;
  height: 0.8rem;
  text-align: center;
  margin-top: 0.6rem;
  font-size: 0.28rem;
  color: #999;
  line-height: 0.32rem;
}
.vanboxb {
  display: flex;
  flex-direction: row;
  margin-top: 0.6rem;
}
.vanboxbl {
  width: 2.6rem;
  height: 0.96rem;
  background: #f5f5f5;
  line-height: 0.96rem;
  text-align: center;
}
.vanboxbr {
  width: 2.6rem;
  height: 0.96rem;
  background: #f5f5f5;
  color: #e52b25;
  line-height: 0.96rem;
  text-align: center;
}
.addpopup .van-popup {
  border-radius: 0.3rem !important;
}
.paypopup-wrap .van-popup {
  border-top-left-radius: 0.2rem !important;
  border-top-right-radius: 0.2rem !important;
}
.paypopup {
  width: 100%;
}
.paypopup-close {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 1.08rem;
  margin-bottom: 0.1rem;
}
.paypopup-close img {
  width: 0.4rem;
  height: 0.4rem;
  position: absolute;
  top: 0.34rem;
  right: 0.24rem;
}
.paypopup-amount {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 0.65rem;
  font-size: 0.46rem;
  color: #333;
  font-weight: bold;
  margin-bottom: 0.4rem;
}
.paypopup-useBalance {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 0.98rem;
  padding: 0 0.44rem 0 0.36rem;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
}

.useBalance-l {
  font-size: 0.28rem;
  color: #e52b25;
  font-weight: 500;
}
.useBalance-r {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.useBalance-r .useBalance-text {
  font-size: 0.28rem;
  color: #e52b25;
  font-weight: 500;
  margin-right: 0.17rem;
}
.useBalance-r img {
  width: 0.42rem;
  height: 0.42rem;
}
.paypopup-useBalance.disabled .useBalance-l,
.paypopup-useBalance.disabled .useBalance-text {
  color: #ccc;
}
.paypopup-useBalance.disabled .radius1 {
  border: 1px solid #ccc;
}
.paypopup-otherTitle {
  padding-left: 0.34rem;
  height: 0.42rem;
  font-size: 0.3rem;
  color: #333;
  font-weight: bold;
  margin: 0.1rem 0 0.24rem;
}
.paypopup-order {
  width: 100%;
  text-align: center;
  color: #999;
  font-size: 0.32rem;
  margin-top: 0.36rem;
}
.paypopup-money {
  width: 100%;
  font-size: 0.46rem;
  text-align: center;
  font-weight: 500;
  line-height: 0.9rem;
  margin-top: 0.05rem;
}
.paypopup-balance {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 0.98rem;
  margin-top: 1.01rem;
  padding: 0 0.36rem;
  padding-right: 0.44rem;
}
.paypopup-balancel {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}
.paypopup-balancel .balancePay {
  margin-left: 0.28rem;
  display: flex;
  flex-direction: column;
  .text {
    font-size: 0.28rem;
    line-height: 0.4rem;
  }
  .red {
    font-size: 0.2rem;
    color: #e52b25;
    line-height: 0.28rem;
  }
}
.paypopup-balancel img {
  width: 0.4rem;
}
.choosecolour {
  background: #f5f5f5;
}
.paypopup-weixin {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 0.98rem;
  padding: 0 0.36rem;
  padding-right: 0.44rem;
}
.paypopup-weixinl span {
  margin-left: 0.28rem;
  font-size: 0.28rem;
  line-height: 1.08rem;
}
.paypopup-weixinl img {
  width: 0.4rem;
}
.paypopup-pay {
  height: 0.98rem;
  background: #e52b25;
  line-height: 0.98rem;
  font-size: 0.3rem;
  text-align: center;
  color: #fff;
  margin-top: 1rem;
  font-weight: bold;
}
.line {
  width: 100%;
  height: 0.2rem;
  background: #f8f9fb;
}
.grey {
  color: #999;
}
.paypopup-closel-x {
  font-weight: bold;
  font-size: 0.34rem;
  color: #333333;
  margin: 0 auto;
}
.radius {
  width: 0.42rem;
  height: 0.42rem;
  border-radius: 50%;
  border: 1px solid #ccc;
  box-sizing: border-box;
}
.paypopup-weixinr img {
  width: 0.42rem;
}
.radius1 {
  width: 0.42rem;
  height: 0.42rem;
  border-radius: 50%;
  border: 1px solid #333;
  box-sizing: border-box;
}
.paypopup-balancer img {
  width: 0.42rem !important;
}
.paypopup-weixinr img {
  width: 0.42rem !important;
}
.tu {
  width: 100%;
  height: 0.06rem;
}
.tu img {
  width: 100%;
  height: 0.06rem;
  display: block;
}

.serverTime{
  height: .65rem;
  width: 100%;
  display: flex;
  padding: 0 .22rem;
  box-sizing: border-box;
  align-items: center;
  background: #fff;
  font-size: 0.22rem;
  img{
    width: 0.32rem;
    height: 0.32rem;
  }
  span{
    color: #333;
    font-size: 0.22rem;
    line-height: 1.5;
  }
}
.noticeBox{
  width: 5.6rem;
  background-color: #fff;
  border-radius: .16rem;display: flex;flex-direction:column;align-items: center;justify-content: center;
  .title{
    text-align: center;height: .8rem;
    line-height: .8rem;font-size: .28rem;
    color: #333;font-weight: 600;
  }
  img{
    width: 4.7rem;
    height: 2.6rem;
    background: #ccc;
    margin-bottom: 0.2rem;
  }
  .contentArea{
    max-height: 4.05rem;
    overflow: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .content{
    width: 4.7rem;padding: 0 0 0.1rem;
    display: flex;
    justify-content: center;
    span{
      line-height: 1.4;
      font-size: .22rem;
      color: #8C8C8C;
      text-align: left;
      word-break: break-all;
    }
  }
  .checkBtn{
    border-top: 1px solid #e5e5e5;
    height: 0.98rem;display: flex;
    align-items: center;justify-content: center;
    color: #FF1616;font-size: 0.3rem;
    width: 100%;
  }
}
.setting{
  width: 100%;
  height: .9rem;
  background: #fff;
  box-sizing: border-box;
  padding: 0 .24rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: .2rem;
}
.settingLeft{
  display: flex;
  flex-direction: column;
  
}
.settingLeft span:nth-child(1){
  line-height: .33rem;
  font-size: .24rem;
  font-weight: bold;
  color: #333;
}
.settingLeft span:nth-child(2){
   line-height: .28rem;
  font-size: .20rem;
  color: #B3B3B3;
}
.zitiTitle{
  width: 100%;
  height: .8rem;
  padding-left: .24rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  span{
    font-size: .28rem;
    color: #333;
    font-weight: 500;
  }
}
.pickTypeItem {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  height: 0.98rem;
  padding: 0 0.24rem;
  background:#fff;
  border-bottom: .01rem solid #eee;
  span{
    font-size: .28rem;
    color: #333;
  }
}
</style>
<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// src/components/index/placeorder.vue